import contentfulGql from 'js/lib/contentfulGql';

import { entWebsiteBlockAssemblyFragment } from 'bundles/ent-website/queries/EntWebsiteBlockAssembly';

export const entWebsiteCtaFragment = contentfulGql`#graphql
  fragment EntWebsiteCta on EntWebsiteCtaBlock {
    slug
    headline
    subhead
    ctaButton1Text
    ctaButton1Target
    ctaButton2Text
    ctaButton2Target
    subCtaText { json }
    subCtaTextMarkdown
  }
`;

export const entWebsiteBlockCtaQuery = contentfulGql`#graphql
  ${entWebsiteBlockAssemblyFragment}
  ${entWebsiteCtaFragment}

  query entWebsiteBlockCta($id: String!, $preview: Boolean, $locale: String!) {
    entWebsiteBlockAssembly(id: $id, preview: $preview, locale: $locale) {
      ...EntWebsiteBlockAssembly
      reference {
        __typename
        ...EntWebsiteCta
      }
    }
  }
`;
